<template>
  <div class="section-title" aria-label="Section title">
    <!-- color can be either a color code or a color class -->
    <div class="title-container" :class="`${color} border`" :style="{'border-color': color}">
      <h1 class="title" :class="`${textColor} color`" :style="{'color': textColor, fontSize: size}"><slot /></h1>
    </div>
    <help-tooltip v-if="hasTooltip" type="info">
      <slot name="tooltip" />
    </help-tooltip>
    <div v-if="hasSubtitle" class="subtitle-container" :class="`${textColor} color`" :style="{'color': textColor}">
      <slot name="subtitle" />
    </div>
  </div>
</template>

<script>
import HelpTooltip from '~lib/common/components/HelpTooltip.vue';

export default {
  name: 'section-title',
  components: {
    HelpTooltip,
  },
  props: {
    color: {
      type: String,
      default: ''
    },
    textColor: {
      type: String,
      default: 'gray-7',
    },
    size: {
      type: String,
      default: '40px',
    },
  },
  data() {
    return {};
  },
  computed: {
    hasTooltip() {
      return !!this.$slots.tooltip;
    },
    hasSubtitle() {
      return !!this.$slots.subtitle;
    },
  },
};
</script>

<style scoped>
.section-title {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.title-container {
  border-bottom: 3px solid #3f83c5;
  margin-right: 8px;
  display: inline-block;
}

.title {
  color: #ffffff;
  line-height: normal;
  letter-spacing: normal;
  margin: 0;
}

.subtitle-container {
  width: 100%;
  font-size: 16px;
  margin-top: 4px;
  font-weight: 500;
}
</style>
